import axios from "axios";
import { ADMIN_API_BASE } from "./adminApiConfig";
import adminRequest from "./adminRequest";

export interface AddAdminCodeResponse {
  code: number;
  message: string;
  data: { code: string } | null;
}

const addAdminCode = async (
  rawCode: string
): Promise<AddAdminCodeResponse> => {
  try {
    return await adminRequest<AddAdminCodeResponse>({
      method: "POST",
      url: `${ADMIN_API_BASE}/api/admin/codes`,
      data: { code: rawCode },
    });
  } catch (error) {
    if (axios.isAxiosError(error) && error.response?.data?.code) {
      return error.response.data as AddAdminCodeResponse;
    }
    return { code: 500, message: "Greška", data: null };
  }
};

export default addAdminCode;
